var map = {
	"./decidim/avatar-multiuser.png": 98498,
	"./decidim/brands/facebook.svg": 3412,
	"./decidim/brands/google.svg": 66477,
	"./decidim/brands/twitter-x.svg": 18174,
	"./decidim/cc-badge.png": 14076,
	"./decidim/decidim-logo.svg": 70000,
	"./decidim/default-avatar.svg": 40328,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 44084,
	"./decidim/icons.svg": 63395,
	"./decidim/pattern.png": 36724,
	"./decidim/placeholder-card-g.svg": 52353,
	"./decidim/placeholder-card-l.svg": 52618,
	"./decidim/placeholder.jpg": 87225,
	"./decidim/remixicon.symbol.svg": 41325,
	"./decidim/vendor/social-share-button/douban.svg": 92604,
	"./decidim/vendor/social-share-button/email.svg": 74553,
	"./decidim/vendor/social-share-button/facebook.svg": 61967,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 57873,
	"./decidim/vendor/social-share-button/hacker_news.svg": 33049,
	"./decidim/vendor/social-share-button/linkedin.svg": 62393,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 96282,
	"./decidim/vendor/social-share-button/pinterest.svg": 37535,
	"./decidim/vendor/social-share-button/reddit.svg": 74723,
	"./decidim/vendor/social-share-button/telegram.svg": 98038,
	"./decidim/vendor/social-share-button/tumblr.svg": 68309,
	"./decidim/vendor/social-share-button/twitter.svg": 2728,
	"./decidim/vendor/social-share-button/vkontakte.svg": 59398,
	"./decidim/vendor/social-share-button/wechat.svg": 22657,
	"./decidim/vendor/social-share-button/whatsapp.svg": 83945,
	"./decidim/vendor/social-share-button/x.svg": 5249,
	"./decidim/vendor/social-share-button/xing.svg": 26895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21775;